/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostPressReleaseHistoryRequestBodyImages
 */
export interface PostPressReleaseHistoryRequestBodyImages {
    /**
     * 画像のファイル名
     * @type {string}
     * @memberof PostPressReleaseHistoryRequestBodyImages
     */
    fileName: string;
    /**
     * 画像のS3ファイル名
     * @type {string}
     * @memberof PostPressReleaseHistoryRequestBodyImages
     */
    fileNameS3: string;
}

export function PostPressReleaseHistoryRequestBodyImagesFromJSON(json: any): PostPressReleaseHistoryRequestBodyImages {
    return PostPressReleaseHistoryRequestBodyImagesFromJSONTyped(json, false);
}

export function PostPressReleaseHistoryRequestBodyImagesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressReleaseHistoryRequestBodyImages {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': json['file_name'],
        'fileNameS3': json['file_name_s3'],
    };
}

export function PostPressReleaseHistoryRequestBodyImagesToJSON(value?: PostPressReleaseHistoryRequestBodyImages | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file_name': value.fileName,
        'file_name_s3': value.fileNameS3,
    };
}

